import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73d28bf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "carousel-indicators" }
const _hoisted_3 = ["data-bs-target", "data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["href", "target"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.images.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: _ctx.uniqueId,
        class: "carousel slide",
        "data-bs-ride": "carousel"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `inidcator-${_ctx.uniqueId}-${index}`,
              type: "button",
              "data-bs-target": `#${_ctx.uniqueId}`,
              "data-bs-slide-to": index,
              class: _normalizeClass({'active': index == 0}),
              "aria-current": index == 0 ? true : false,
              "aria-label": `Slide ${index + 1}`
            }, null, 10, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: `image-${_ctx.uniqueId}-${index}`,
              class: _normalizeClass(["carousel-item position-relative", {'active': index == 0}]),
              href: image.linkTo || '',
              target: image.openNewPage ? '_blank' : '_self',
              style: _normalizeStyle(!image.linkTo && 'pointer-events: none;')
            }, [
              (image.srcMobile && _ctx.isMobile)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `${require('@/assets/' + image.srcMobile.replace(/^\//g, ''))}`,
                    class: "d-block w-100",
                    alt: image.alt || ''
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: `${require('@/assets/' + image.src.replace(/^\//g, ''))}`,
                    class: "d-block w-100",
                    alt: image.alt || ''
                  }, null, 8, _hoisted_7))
            ], 14, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "carousel-control-prev",
          type: "button",
          "data-bs-target": `#${_ctx.uniqueId}`,
          "data-bs-slide": "prev"
        }, _hoisted_11, 8, _hoisted_8),
        _createElementVNode("button", {
          class: "carousel-control-next",
          type: "button",
          "data-bs-target": `#${_ctx.uniqueId}`,
          "data-bs-slide": "next"
        }, _hoisted_15, 8, _hoisted_12)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}